export const BackwardsCompatibleAddressFragment = gql`
  fragment BackwardsCompatibleLocationInformationFragment on BackwardsCompatibleLocationInformation {
    address {
      str
    }
    addressEntityUuid
    coordinates {
      ...CoordinateFragment
    }
    entityId
    entityVersionId
    fieldId
    fields {
      key
      value
    }
    isManualAddress
    locationObjectId
    parcelDisplayName
    parcelEntityUuid
    propertyOwner
    propertyOwnerMailingAddress {
      str
    }
  }
`

export const BackwardsCompatibleLocationFieldFragment = gql`
  fragment BackwardsCompatibleLocationFieldFragment on BackwardsCompatibleLocationField {
    entityFieldTemplateId
    key
    value
  }
`
